<div class="card card-default h-100">
  <div class="card-header h5">
    <div [ngClass]="headerHaloClass" class="badge badge-pill text-white">
      <span [innerHTML]="headerText"
      [title]="headerTitle"></span>
    </div>
  </div>
  <div class="card-body">
    <div class="row mb-2">
      <div class="col-12">
        <div class="form-check d-inline-block mr-3">
          <input (click)="setIsRange(false)" [checked]="!config.range" [name]="kind" class="form-check-input"
            [disabled]="!isHigherThanAdmin"
            id="radioSingleValue{{kind}}"
            type="radio">
            <label class="form-check-label" for="radioSingleValue{{kind}}" translate>Single value</label>
          </div>
          <div class="form-check d-inline-block">
            <input (click)="setIsRange(true)" [checked]="config.range" [name]="kind" [value]="config.range"
              [disabled]="!isHigherThanAdmin"
              class="form-check-input"
              id="radioRange{{kind}}" type="radio">
              <label class="form-check-label" for="radioRange{{kind}}" translate>Range of values</label>
            </div>
          </div>
        </div>
        @if (!config.range) {
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" translate>Value</span>
              </div>
              <input [(ngModel)]="config.startF" [disabled]="!isHigherThanAdmin" class="form-control" type="number">
            </div>
          </div>
        }
        @if (config.range) {
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" translate>Start</span>
              </div>
              <input [(ngModel)]="config.startF" [disabled]="!isHigherThanAdmin" class="form-control" type="number">
            </div>
          </div>
        }
        @if (config.range) {
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" translate>End</span>
              </div>
              <input [(ngModel)]="config.endF" [disabled]="!isHigherThanAdmin" class="form-control" type="number">
            </div>
          </div>
        }
      </div>
    </div>
